<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-self-selected`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm0 4C14.059 6 6 14.059 6 24s8.059 18 18 18 18-8.059 18-18S33.941 6 24 6zm12.551 10.336a1 1 0 01.708 1.707L32.602 22.7a.993.993 0 01-.133.111.028.028 0 00-.009.007l-7.778 7.778a1 1 0 01-1.327.078l-.087-.078-4.243-4.242-5.657 5.656a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l7.778-7.778a1 1 0 011.414 0l4.243 4.242 5.079-5.08-2.523-2.523a1.001 1.001 0 01-.285-.576l-.008-.131a1 1 0 011-1h9.313z"/></svg>
</template>
<script>

export default {
  name: 'IconSelfSelected',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
